export default __webpack_public_path__ + "static/4-75fa94092038fec49b7aaa352320c05d.jpg";